import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DesignPanel from './components/DesignPanel';
import Header from './components/Header';
import ReportModel from './components/ReportModel';
import {
  getReportModelViews,
  getSelectedViewId,
  hasUnsavedChanges,
} from './selectors/report-model-designer.selectors';
import { clearErrors } from '../actions/ErrorActions';
import { clearWarnings } from '../actions/WarningActions';
import UnsavedChangesPrompt from '../components/UnsavedChangesPrompt';
import { equalityFn } from '../form-designer/utils/form-manager.utils';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    display: 'flex',
    height: 'calc(100vh - 147px)',
  },
  wrapperStyled: {
    display: 'flex',
    height: 'calc(100vh - 66px)',
    overflow: 'hidden',
  },
  reportWrapperStyled: {
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  reportContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 100%',
    minWidth: 0,
    height: '97vh',
    overflow: 'hidden',
  },
});

const ReportModelDesigner = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const unsavedChanges = useSelector(hasUnsavedChanges);
  const views = useSelector(getReportModelViews, equalityFn);
  const selectedViewId = useSelector(getSelectedViewId, equalityFn);

  useEffect(
    () => () => {
      dispatch(clearErrors());
      dispatch(clearWarnings());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={classes.wrapperStyled}>
      <div className={classes.reportWrapperStyled}>
        <div className={classes.reportContainer}>
          <Header />
          <div className={classes.container}>
            <ReportModel views={views} selectedViewId={selectedViewId} />
            <DesignPanel />
          </div>
        </div>
      </div>
      <UnsavedChangesPrompt hasUnsavedChanges={unsavedChanges} />
    </div>
  );
};

export default ReportModelDesigner;
